import { makeStyles, tokens } from "@fluentui/react-components";

export const useCardStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    boxSizing: "border-box",
    padding: "12px 16px",
    fontWeight: tokens.fontWeightMedium,
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  headerTitleGroup: {
    display: "flex",
    flexDirection: "column",
    color: tokens.colorNeutralForeground1,
  },
  headerIcon: {
    display: "flex",
    alignItems: "center",
  },
  headerTitle: {
    fontSize: "14px",
    fontWeight: tokens.fontWeightMedium,
    margin: 0,
  },
  largeNumber: {
    fontSize: "40px",
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground1,
  },

  /* ---- Content Section ---- */
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
  },
  /* ---- Info List (dl > dt/dd rows) ---- */
  column: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    margin: 0,
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  label: {
    textAlign: "right",
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  value: {
    textAlign: "center",
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
});
